import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function KeepBotDialog({ open, setOpen, response, title }) {
  const [secondsLeft, setSecondsLeft] = useState(30); // change duration as needed

  useEffect(() => {
    if (open) {
      setSecondsLeft(300); // reset timer when dialog opens
      const timer = setInterval(() => {
        setSecondsLeft(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            response("no_response"); // auto respond on timeout
            setOpen(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer); // cleanup
    }
  }, [open]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec.toString().padStart(2, '0')}`;
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Alert From Liznr"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {title}
          </DialogContentText>
          <DialogContentText style={{ fontWeight: 'bold', fontSize: '1.5rem', marginTop: '1rem', textAlign: 'center' }}>
            {formatTime(secondsLeft)} remaining
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => response("no")}>No</Button>
          <Button onClick={() => response("yes")}>Yes</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
